import { CompanyLogo } from '@/features/form-editing/components';

import { FORM_TITLE_CLASS } from '@/shared/constants/form-typography';

import { cn } from '@/lib/utils';

interface IFormFillHeaderProps {
	logoUrl?: string;
	title: string;
	className?: string;
}

function FormFillHeader({ logoUrl, title, className }: IFormFillHeaderProps) {
	return (
		<div className={cn('relative flex flex-col gap-2 px-1', className)}>
			{logoUrl && (
				<CompanyLogo
					logoUrl={logoUrl}
					editMode={false}
					compactSpacing
					className={cn('mx-0 w-fit max-w-[calc(100%-80px)] md:max-w-[calc(100%-128px)]')}
				/>
			)}
			<h1 className={FORM_TITLE_CLASS}>{title}</h1>
		</div>
	);
}

export default FormFillHeader;
